// ─── Données de l'onglet FAMILLE (My Calendar) ────────────────────
// Le RENDU vit dans le Core (HubTuiles / AVenir) ; ici uniquement les données :
// sections, tuiles, destination et périmètre (clés i18n `famille.*` / `avenir.*`).
//
// `fn`    = clé de FONCTION du catalogue : c'est elle qui décide si la tuile est
//           accessible (porte de forfait). Sans `fn`, la tuile l'est toujours.
// `porte` = la tuile est PORTÉE (écran réel) ; sinon écran « à venir ».
// `dest`  = module d'accueil quand la fonction sera portée.
// `desc`  = clé i18n de la description (bloc `famille.*Desc`).
export const FAMILLE_SECTIONS = [
  { cle: 'collaboration', tuiles: [
    { cle: 'messagerie', emoji: '💬', fn: 'messagerie', desc: 'messagerieDesc', dest: 'core', ecran: 'messagerie', porte: true },
    { cle: 'journal', emoji: '📔', fn: 'journal', desc: 'journalDesc', dest: 'mycalendar', ecran: 'journal' },
    { cle: 'finances', emoji: '💶', fn: 'budget', desc: 'budgetDesc', dest: 'finance' },
  ] },
  { cle: 'garde', tuiles: [
    { cle: 'demandes', emoji: '🧷', fn: 'calendrier.demandes', desc: 'demandesDesc', porte: true },
    { cle: 'statistiques', emoji: '📊', fn: 'statistiques', desc: 'statistiquesDesc', dest: 'mycalendar', ecran: 'statistiques' },
  ] },
  { cle: 'organisation', tuiles: [
    { cle: 'listes', emoji: '📝', fn: 'listes', desc: 'listesDesc', dest: 'core', ecran: 'listes' },
    { cle: 'repas', emoji: '🍲', fn: 'repas', desc: 'repasDesc', dest: 'meals', ecran: 'repas' },
    { cle: 'menu', emoji: '🍽️', fn: 'repas', desc: 'menuDesc', dest: 'meals', ecran: 'menu' },
    { cle: 'courses', emoji: '🛒', fn: 'courses', desc: 'coursesDesc', dest: 'meals', ecran: 'courses' },
  ] },
  // Carnets = données de RÉFÉRENCE partagées (pas des fonctions calendrier de 1er
  // niveau) : réutilisées par les événements (lieu) et bonnes à avoir sous la main.
  { cle: 'carnets', tuiles: [
    { cle: 'contacts', emoji: '👥', fn: 'contacts', desc: 'contactsDesc', dest: 'core', ecran: 'contacts' },
    { cle: 'lieux', emoji: '📍', fn: 'lieux', desc: 'lieuxDesc', dest: 'core', ecran: 'lieux' },
  ] },
  { cle: 'outils', tuiles: [
    { cle: 'historique', emoji: '🕰️', fn: 'historique', desc: 'historiqueDesc', dest: 'core', ecran: 'historique' },
    { cle: 'exports', emoji: '📤', fn: 'export', desc: 'exportDesc', dest: 'transverse', ecran: 'export' },
  ] },
];
